import { render, staticRenderFns } from "./indexInsUserPay.vue?vue&type=template&id=a5ccc348&scoped=true"
import script from "./indexInsUserPay.vue?vue&type=script&lang=js"
export * from "./indexInsUserPay.vue?vue&type=script&lang=js"
import style0 from "./indexInsUserPay.vue?vue&type=style&index=0&id=a5ccc348&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ccc348",
  null
  
)

export default component.exports